import { RouteConfig } from "vue-router";

export const RCandidateServicesBrowse: RouteConfig = {
  name: "CandidateServicesBrowse",
  path: "",
  component: () =>
    import(
      /* webpackChunkName: "candidate-cases-browse" */
      "./VCandidateServicesBrowse.vue"
    ),
  meta: {
    title: "Cases",
  },
};

export const RExpertServicesBrowse: RouteConfig = {
  name: "ExpertServicesBrowse",
  path: "",
  component: () =>
    import(
      /* webpackChunkName: "candidate-cases-browse" */
      "./VExpertServicesBrowse.vue"
    ),
  meta: {
    title: "Cases",
  },
};
